import { DockviewApi } from 'dockview';
import { useEffect, useRef } from 'react';
import { useFocusedTab } from '@/features/tab/route-tab/model/useFocusedTab';
import { useGobackTab } from './useGobackTab';

/**
 * 브라우저 뒤로가기 버튼을 탭 이전 화면으로 연결.
 * useTabFocusSync에서 push를 사용해 히스토리에 추가하므로,
 * popstate 발생 시 goback()으로 탭 상태를 이전 화면으로 되돌림.
 */
export function useBrowserBackHandler(api: DockviewApi | null) {
  const focusedTab = useFocusedTab(api);
  const tabId = focusedTab?.tabId ?? '';
  const { goback, canGoBack } = useGobackTab(tabId, api);

  const gobackRef = useRef(goback);
  const canGoBackRef = useRef(canGoBack);
  gobackRef.current = goback;
  canGoBackRef.current = canGoBack;

  useEffect(() => {
    if (!api) return;

    const handlePopState = () => {
      if (canGoBackRef.current) {
        gobackRef.current();
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [api]);
}
